<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">
              New Job
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-6">
                  <h2>Job Detail</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Job</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="description">Description:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    ref="job_description"
                    name="description"
                    placeholder="description"
                    v-model="description"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="notes">Notes:</label>
                </div>
                <div class="col-9">
                  <textarea
                    rows="4"
                    class="form-control"
                    id="notes"
                    ref="site_notes"
                    name="notes"
                    placeholder="notes"
                    v-model="notes"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <h3>Plants</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>Available Plants</label>
                </div>
                <div class="col-6">
                  <label>Selected Plants</label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <draggable
                    class="h-min-200 h-100 p-0 d-block"
                    tag="ul"
                    v-model="plant_list"
                    v-bind="dragOptions"
                    :move="onMove"
                    @start="isDragging = true"
                    @end="isDragging = false"
                  >
                    <transition-group
                      type="transition"
                      :name="'plant-list'"
                      class="d-block h-100"
                    >
                      <li
                        class="plant-select-item"
                        v-for="element in plant_list"
                        :key="id + 'pera' + element.id"
                      >
                        <i
                          :class="
                            element.fixed
                              ? 'fa fa-anchor'
                              : 'glyphicon glyphicon-pushpin'
                          "
                          @click="element.fixed = !element.fixed"
                          aria-hidden="true"
                        ></i>
                        {{ element.name }}
                      </li>
                    </transition-group>
                  </draggable>
                </div>
                <div class="col-6">
                  <draggable
                    class="h-min-200 h-100 p-0"
                    tag="ul"
                    v-model="selected_plants"
                    v-bind="dragOptions"
                    :move="onMove"
                    @start="isDragging = true"
                    @end="isDragging = false"
                  >
                    <transition-group name="no" class="d-block h-100">
                      <li
                        class="plant-select-item"
                        v-for="element in selected_plants"
                        :key="id + 'plant' + element.id"
                      >
                        <i
                          :class="
                            element.fixed
                              ? 'fa fa-anchor'
                              : 'glyphicon glyphicon-pushpin'
                          "
                          @click="element.fixed = !element.fixed"
                          aria-hidden="true"
                        ></i>
                        {{ element.name }}
                      </li>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions, mapState } from "vuex";

export default {
  name: "NewJobModal",
  props: {
    customer_id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    description: "",
    notes: "",
    selected_plants: [],
    plant_list: [],
  }),
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    customer_id() {
      this._reload();
    },
    plants() {
      this._reload();
    },
    job() {
      this._reload();
    },
  },
  mounted: function() {
    this.id = this._uid;
    this.$nextTick(function() {
      this._reload();
    });
  },
  computed: {
    ...mapState("plants", ["plants"]),
    ...mapState("sites", ["sites"]),
    ...mapState("customers", ["customers"]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    ...mapActions("jobs", ["apiCreateJob"]),
    _reload() {
      var vm = this;
      this.selected_plants = [];
      var sites = this.sites.filter(function(value) {
        return value.customer_id == vm.customer_id;
      });
      this.plant_list = this.plants.filter(function(value) {
        var site_index = sites.findIndex(v => v.id == value.site_id);
        var index = vm.selected_plants.findIndex(v => v.id == value.id);
        return site_index > -1 && index < 0;
      });
      if (this.description == "" && this.customers && this.customer_id) {
        var index = this.customers.findIndex(v => v.id == this.customer_id);
        if (index > -1) {
          this.description = this.customers[index].name;
        }
      }
    },
    _save() {
      if (!this.$refs.job_description.value) {
        alert("please enter a description");
        return;
      } else if (this.selected_plants.length < 1) {
        alert("please select at least a plant");
        return;
      }
      var job = {
        id: 0,
        description: this.$refs.job_description.value,
        customer_id: this.customer_id,
        plants: this.selected_plants,
        notes: this.notes,
        active: true,
      };
      this.apiCreateJob(job);
      this.$emit("close");
    },
    clear() {
      this.name = "";
      this.notes = "";
      if (this.customers && this.customer_id) {
        var index = this.customers.findIndex(v => v.id == this.customer_id);
        if (index > -1) {
          this.description = this.customers[index].name;
        }
      }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
  },
  components: { draggable },
};
</script>
